import React from 'react';
import { useTranslation } from 'react-i18next';
import css from './excel-button-new.module.css';
import excelIcon from './excel-icon.svg';

interface Props {
  onClick: () => void;
  id?: string;
}

export default function ExcelButtonNew({ onClick, id = null }: Props) {
  const { t } = useTranslation();
  return (
    <div id={id} className={css['container']}>
      <div
        onClick={onClick}
        className={`${css['export-button']} ${css['export-icon']}`}
        data-tip
        data-for="export_to_excel_tooltip"
      >
        <img src={excelIcon} alt="" />
        <h1 className={css['excel-button-title']}>{t('export_to_excel')}</h1>
      </div>
    </div>
  );
}
